module.exports = __webpack_public_path__ + "static/media/Yelp_trademark_RGB_outline.b9bda6b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Yelp_trademark_RGB_outline.png
// module id = 187
// module chunks = 0